import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import LandingPage from './pages/LandingPage';
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import OnboardingPage from './pages/OnboardingPage';
import DashboardPage from './pages/DashboardPage';
import DealDetailPage from './pages/DealDetailPage';
import ProfilePage from './pages/ProfilePage';
import AdminDashboard from './pages/AdminDashboard';
import PendingApprovalPage from './pages/PendingApprovalPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import StartupFormPage from './pages/StartupFormPage';
import SharedDealPage from './pages/SharedDealPage';
import './App.css';

// Router component
function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/pending" element={<PendingApprovalPage />} />
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/change-password" element={<ChangePasswordPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/deals/:dealId" element={<DealDetailPage />} />
      <Route path="/share/:dealId" element={<SharedDealPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/:tab" element={<AdminDashboard />} />
      <Route path="/admin/:tab/:subtab" element={<AdminDashboard />} />
      <Route path="/startupform" element={<StartupFormPage />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Toaster position="top-center" richColors />
        <AppRouter />
      </div>
    </Router>
  );
}

export default App;
